import { InMemoryCache, ReactiveVar, makeVar } from '@apollo/client';
import introspectionResult from './generated/fragment-matcher';
import { Organization, User } from './generated/graphql';
import { AvailableError } from './operations/commands/Errors';

export const cache: InMemoryCache = new InMemoryCache({
  addTypename: true,
  possibleTypes: introspectionResult.possibleTypes,
  typePolicies: {
    Query: {
      fields: {
        currentUser: {
          read() {
            return currentUserVar();
          },
        },
        lastAccessedOrganization: {
          read() {
            return lastAccessedOrganizationVar();
          },
        },
        errors: {
          read() {
            return errorsVar();
          },
        },
        availableOrganizations: {
          read() {
            return availableOrganizationsVar();
          },
        },
      },
    },
  },
});

/**
 * Set initial values when we create cache variables.
 */

export const currentUserVar: ReactiveVar<User | null> = makeVar<User | null>(null);

const storedOrg = localStorage.getItem('lastAccessedOrganization');

function isJson(data: string) {
  try {
    JSON.parse(data);
  } catch (e) {
    return false;
  }
  return true;
}

export const lastAccessedOrganizationVar: ReactiveVar<Organization | null> = makeVar<Organization | null>(
  storedOrg && isJson(storedOrg) ? JSON.parse(storedOrg) : null,
);

export const availableOrganizationsVar: ReactiveVar<Organization[] | null> = makeVar<Organization[] | null>(null);
export const errorsVar: ReactiveVar<AvailableError[] | null> = makeVar<AvailableError[] | null>(null);
